import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BreadcrumbComponent } from '../../breadcrumb/breadcrumb.component';
import { FooterComponent } from '../../footer/footer.component';
import { HeaderComponent } from '../../header/header.component';
import { LoaderComponent } from '../../loader/loader.component';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.scss'],
  imports: [FooterComponent, LoaderComponent, RouterOutlet, HeaderComponent, BreadcrumbComponent],
})
export class ContentLayoutComponent implements OnInit {
  constructor(
      private viewportScroller: ViewportScroller) {}
  ngOnInit() {
    
    this.viewportScroller.scrollToPosition([0, 0]);
  }

  toggleSwitcherBody() {}

  scrolled: boolean = false;
}
